<div class="mb-32 relative w-full md:max-w-[1312px] px-24 md:pl-[38px] md:pr-24 mx-auto">

  <!-- Wrapper -->
  <div class="flex flex-col p-24 gap-12 bg-white/[0.5] border backdrop-blur-md rounded-lg border-gray-10">

    <div *ngIf="stageActive && stageActive.type !== 3"
      class="flex flex-col md:flex-row relative z-10 w-full justify-between gap-12">

      <!-- Content -->
      <div class="flex w-full mb-0 bg-white/[0.5] border backdrop-blur-md rounded-lg border-gray-10">

        <div class="w-full py-8 md:py-12 px-12 md:px-20">

          <div class="flex flex-col md:flex-row justify-between gap-y-24 gap-x-64">

            <div class="flex flex-col">
              <div class="flex gap-6 items-center">
                <div class="flex gap-6 items-center text-center w-fit px-8 rounded-lg pt-[3px] pb-2 bg-[#e0e3ff]">
                  <fun-icon [name]="'circle'" [style]="'w-12 h-12 fill-verified'"></fun-icon>
                  <p *ngIf="this.detailProject['highestUserGroup'] !== undefined"
                    class="font-sans text-s md:text-m text-verified"><span class="hidden md:inline-block">{{
                      'OVERVIEW_PROJECT.GROUPS.ACCREDITED_OK' | translate }}</span>
                    ({{ this.detailProject['userGroups'] }})</p>
                  <p *ngIf="this.detailProject['highestUserGroup'] === undefined"
                    class="font-sans text-s md:text-m text-verified"><span class="hidden md:inline-block">{{
                      'OVERVIEW_PROJECT.GROUPS.ACCREDITED_NULL' | translate }}</span>
                    (S/D)</p>
                </div>

                <div class="flex gap-6 cursor-help relative has-tooltip">
                  <p class="font-sans text-s text-left leading-[1.25]">{{ 'OVERVIEW_PROJECT.GROUPS.WHAT.TXT' | translate
                    }}</p>
                  <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
                  <span
                    class="font-sans text-s rounded shadow-lg !py-4 !px-6 bg-eggplant-100 text-cream-100 leading-[1.2] -mt-64 tooltip">{{
                    'OVERVIEW_PROJECT.GROUPS.WHAT.TOOLTIP' | translate }}</span>
                </div>
              </div>

              <!-- Info del grupo -->
              <div *ngIf="this.detailProject['highestUserGroup'] !== undefined && !allUserGroupsFull(stageActive)"
                class="flex flex-col gap-6 py-8">
                <h3 class="text-base font-sans text-m md:text-xl leading-[1.2] text-eggplant-80">
                  {{ this.detailProject['highestUserGroup'].name }}
                </h3>
                <p class="flex flex-col items-center font-sans text-s md:text-m text-eggplant-100/[0.55]">{{
                  'OVERVIEW_PROJECT.GROUPS.INFO.TXT_' + detailProject['highestUserGroup'].priority | translate }}
                </p>
              </div>

              <!-- Info general -->
              <div *ngIf="this.detailProject['highestUserGroup'] === undefined" class="flex flex-col gap-6 py-8">
                <h3 class="text-base font-sans text-m md:text-xl leading-[1.2] text-eggplant-80">
                  {{ 'OVERVIEW_PROJECT.GROUPS.ACCREDITED_NULL' | translate }}
                </h3>
                <p class="flex flex-col items-center font-sans text-s md:text-m text-eggplant-100/[0.55]">{{
                  'OVERVIEW_PROJECT.GROUPS.INFO.TXT_GLOBAL' | translate }}</p>
              </div>
              <!-- Alertas y mensajes: todos los grupos del usuario tienen objetivo completo -->
              <div *ngIf="this.detailProject['highestUserGroup'] !== undefined && allUserGroupsFull(stageActive)"
                class="flex gap-6 mt-8 px-10 py-6 rounded-xl bg-orange-100/15">
                <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-orange-100'"></fun-icon>
                <p class="flex flex-col items-center font-sans text-s md:text-m text-orange-100">{{
                  'OVERVIEW_PROJECT.GROUPS.INFO.TXT_COMPLETED' | translate }}</p>
              </div>

            </div>

            <div class="flex flex-col justify-center items-center gap-12">
              <div>
                <fun-new-button size="l" icon="" iconPosition=""
                  [buttonType]="isProfileRestricted ? 'colorFull-disabled' : mainCtaType"
                  [title]="mainCtaTitle"
                  (eventClick)="!isProfileRestricted && bookInvestment()"></fun-new-button>
              </div>
              <div>
                <fun-new-button size="s" icon="" iconPosition="" [buttonType]="'ghost'" title="{{ 'PRIORITY_GROUP.SEE_GROUPS' | translate }}"
                  (eventClick)="viewDetails(stageWithPriorityGroups)"></fun-new-button>
              </div>
            </div>

          </div>
          <p *ngIf="showConsolidationDateAdvise" class="font-sans text-s text-orange-100">En este momento no puedes
            invertir en este proyecto porque se encuentra en fase de consolidación de reservas.</p>
        </div>
      </div>

    </div>

    <div class="flex gap-6 p-10 rounded-xl border bg-[#EAE7E9] border-gray-10 w-full"
      *ngIf="isProfileRestricted && stageActive && stageActive.type !== 3">
      <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100 flex-shrink-0'"></fun-icon>
      <p class="font-sans text-s text-left leading-[1.25]">
        <ng-container *ngIf="detailProject?.canNaturalInvest === true && detailProject?.canLegalInvest === false">Inversión exclusiva para personas físicas.</ng-container>
        <ng-container *ngIf="detailProject?.canLegalInvest === true && detailProject?.canNaturalInvest === false">Inversión exclusiva para personas jurídicas.</ng-container>
      </p>
    </div>

    <div class="flex flex-col md:flex-row relative z-10 w-full justify-between gap-12">

      <!-- Loop items -->
      <div *ngFor="let stage of detailProject.postal_code_investment_stages; let i = index; let last = last;"
        class="flex flex-col gap-16 md:gap-6 flex-1 w-full relative group">

        <!-- Linea conectora Desktop (Per Item) -->
        <div class="hidden w-full" [ngClass]="{
                  '': last
                }">
          <div class="w-full h-[16px] rounded-lg" [ngClass]="{
                  'bg-gray-10': !isStageActive(i),
                  'bg-gradient-1': isStageActive(i)
                }">
          </div>
        </div>

        <!-- Content -->
        <div
          class="flex flex-col w-full mb-0 bg-white/[0.5] border md:border-eggplant-100/[0.25] backdrop-blur-md rounded-lg"
          [ngClass]="{
                  'border-gray-10': !isStageActive(i),
                  'border-gradient-1': isStageActive(i)
                }">
          <div class="py-8 md:py-12 px-12 md:px-20">

            <div class="flex items-center justify-between gap-12 border-b border-gray-10 pb-12">

              <div class="flex items-center gap-12">
                <div class="flex w-40 h-40 items-center justify-center rounded-lg relative"
                  [ngClass]="{'bg-gradient-1': isStageActive(i), 'bg-success/[0.55]' : isStagePassed(i), 'bg-orange-100' : (!isStageActive(i) && !isStagePassed(i))}">

                  <fun-icon *ngIf="!isStageActive(i)" [name]="isStagePassed(i) ? 'check-circle' : 'clock'"
                    [style]="'w-24 h-24 stroke-[4px] stroke-white'"></fun-icon>

                  <span *ngIf="isStageActive(i)" class="absolute top-[8px] w-12 h-12">
                    <span
                      class="animate-ping absolute top-[6px] inline-flex h-full w-full rounded-full bg-cream-100 opacity-75"></span>
                    <span class="relative inline-flex rounded-full w-12 h-12 bg-cream-100"></span>
                  </span>

                </div>
                <div class="flex flex-col">
                  <h3 class="text-base font-sans text-m md:text-xl leading-[1.2]"
                    [ngClass]="isStageActive(i) ? 'text-eggplant-80' : 'text-gray-25'">
                    {{ stage.title }}
                  </h3>
                  <span class="text-s font-sans tracking-wider"
                    [ngClass]="isStageActive(i) ? 'text-eggplant-100/[0.55]' : 'text-gray-25'">
                    {{ 'OVERVIEW_PROJECT.GROUPS.DATE.PREFIX' | translate }} <span class="uppercase">{{ stage.start_date
                      | date:'d MMM' }}</span>
                  </span>
                </div>
              </div>

            </div>

            <div class="flex items-center justify-between gap-6 pt-12">
              <p class="font-sans text-s md:text-m max-w-[320px] leading-none"
                [ngClass]="isStageActive(i) ? 'text-eggplant-80' : 'text-gray-25'">
                {{ stage.description }}
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div><!-- Fin wrapper -->
</div>